import { render } from "./TransferTransactionForm.vue?vue&type=template&id=52704139&scoped=true"
import script from "./TransferTransactionForm.vue?vue&type=script&lang=js"
export * from "./TransferTransactionForm.vue?vue&type=script&lang=js"

import "./TransferTransactionForm.vue?vue&type=style&index=0&id=52704139&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52704139"]])

export default __exports__